// extracted by mini-css-extract-plugin
module.exports = {"imgWrap":"PhoneDescription_imgWrap_3lVCN","img":"PhoneDescription_img_5KLf2","labels":"PhoneDescription_labels_-lj5X","formWrap":"PhoneDescription_formWrap_29jVi"};